import { createContext } from 'react';
import utils from 'utils';

type CreateDataRoomContextProps = { openCreateDataRoomModal: () => void };

export default createContext<Partial<CreateDataRoomContextProps>>({
  openCreateDataRoomModal: utils.noop,
});
